import CircleIcon from "@mui/icons-material/Circle";
import { useState } from "react";
import ExtraInfoButton from "./ExtraInfoButton";
import ExtraInfoModal from "./ExtraInfoModal";
import modalStyles from "./ExtraInfoModal.module.scss";
import styles from "./RemarksButton.module.scss";

type RemarksButtonProps = {
  content: string | null | undefined;
};

export default function RemarksButton({ content }: RemarksButtonProps) {
  const [open, setOpen] = useState(false);
  const items = parseContent(content);

  if (items.length === 0) return <></>;

  return (
    <>
      <ExtraInfoButton label="Remarks" onClick={() => setOpen(true)} />
      <ExtraInfoModal
        open={open}
        title="Remarks"
        content={items.map((item, index) => (
          <div className={modalStyles.item} key={`${item}-${index}`}>
            <CircleIcon className={styles.circle} />
            <p className={modalStyles.itemText}>{item}</p>
          </div>
        ))}
        onClose={() => setOpen(false)}
      />
    </>
  );
}

function parseContent(content: string | null | undefined) {
  return (content ?? "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
}
